import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import type {
  PartsStyleFunction,
  StyleFunctionProps,
} from '@chakra-ui/theme-tools';

const baseStyle: PartsStyleFunction<typeof parts> = () => ({
  dialog: {
    p: '10',
    borderRadius: '3xl',
  },
  overlay: {
    bg: ['white', 'grey.400'],
  },
  body: {
    px: '0',
    py: '5',
  },
  header: {
    px: '0',
    pb: '2',
  },
  footer: {
    px: '0',
  },
});

export const Modal = {
  baseStyle,
  variants: {
    'republic-dls': {
      dialog: {
        p: '10',
        borderRadius: '3xl',
      },
      overlay: {
        bg: ['white', 'rgba(0, 0, 0, 0.25)'],
      },
      body: {
        px: '0',
        py: '5',
      },
      header: {
        px: '0',
        pb: '2',
      },
      footer: {
        px: '0',
      },
    },
    republic: (props: StyleFunctionProps) => ({
      dialog: {
        p: 0,
        borderRadius: props.size === 'full' ? 0 : 'md',
      },
      overlay: {
        bg: ['white', 'rgba(0, 0, 0, 0.48)'],
      },
      body: {
        px: '6',
        py: '2',
      },
      header: {
        px: '6',
        pb: '4',
      },
      footer: {
        px: '6',
      },
    }),
  },

  sizes: {
    // TODO: Update with unit references from sizes
    'republic-sm': {
      dialog: {
        // maxW: 'container.sm',
        maxW: '640px',
      },
    },
    'republic-md': {
      dialog: {
        // maxW: 'container.md',
        maxW: '768px',
      },
    },
    'republic-lg': {
      dialog: {
        // maxW: 'container.lg',
        maxW: '1024px',
      },
    },
    'republic-xl': {
      dialog: {
        maxW: 'container.xl',
      },
    },
    sm: {
      dialog: {
        maxW: 'container.sm',
      },
    },
    md: {
      dialog: {
        maxW: 'container.md',
      },
    },
    lg: {
      dialog: {
        maxW: 'container.lg',
      },
    },
    xl: {
      dialog: {
        maxW: 'container.xl',
      },
    },
  },
  defaultProps: {
    size: 'republic-md',
  },
};
